
const loadCaptchaBasic = () => import('captcha_basic').then(module => module.default);
export const basic_captcha = loadCaptchaBasic
const loadEmbedBasic = () => import('embed-basic').then(module => module.default);
export const basic_embed = loadEmbedBasic